import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PatientAuthState, PortalPatientInfo, PortalPracticeInfo } from '../../types';

const initialState: PatientAuthState = {
  patientToken: null,
  resourceType: null,
  encodedResourceId: null,
  patientInfo: null,
  practiceInfo: null,
  loading: false,
  error: null,
};

const patientAuthSlice = createSlice({
  name: 'patientAuth',
  initialState,
  reducers: {
    startPatientAuth(state) {
      state.loading = true;
      state.error = null;
    },
    patientAuthSuccess(
      state,
      action: PayloadAction<{
        patientToken: string;
        resourceType: string;
        encodedResourceId: string;
        patientInfo: PortalPatientInfo;
        practiceInfo: PortalPracticeInfo;
      }>
    ) {
      state.loading = false;
      state.patientToken = action.payload.patientToken;
      state.resourceType = action.payload.resourceType;
      state.encodedResourceId = action.payload.encodedResourceId;
      state.patientInfo = action.payload.patientInfo;
      state.practiceInfo = action.payload.practiceInfo;
    },
    patientAuthFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    clearPatientAuth() {
      return initialState;
    },
  },
});

export const {
  startPatientAuth,
  patientAuthSuccess,
  patientAuthFailure,
  clearPatientAuth,
} = patientAuthSlice.actions;
export default patientAuthSlice.reducer;
